import React from 'react';
import classes from './DirectPublishingStatus.module.scss';
import { GetSocialProfiles_workspace_socialProfiles_InstagramSocialProfile } from '../../../models/legacy-graphql';
import { ProfilesViewProps } from '../../../modules/Settings/Profiles/Profiles.view';
import { Button } from '../../actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';

export type DirectPublishingStatusViewProps = {
  //
  breakpoint: 'small' | 'large';
  profile: GetSocialProfiles_workspace_socialProfiles_InstagramSocialProfile;
  setDirectPublishing: ProfilesViewProps['setDirectPublishing'];
};

export const DirectPublishingStatusView = (props: DirectPublishingStatusViewProps): JSX.Element => {
  const buffer = props.profile.directPublishEnabled ? (
    <div className={classes.DirectPublishingStatus}>
      <h6>Direct publishing enabled</h6>
    </div>
  ) : (
    <Button
      expanded={props.breakpoint === 'small' ? true : undefined}
      type={'button'}
      variant={'hollow'}
      size={'small'}
      color={ButtonColorsEnum.primary}
      action={() => props.setDirectPublishing(true, props.profile)}>
      Enable Direct Publishing
    </Button>
  );
  return props.breakpoint === 'large' ? (
    <div className={'cell shrink show-for-large'}>{buffer}</div>
  ) : (
    <div className={'grid-x cell hide-for-large margin-top-small-8'}>{buffer}</div>
  );
};
